import React, { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { FiDownload, FiRefreshCcw } from "react-icons/fi";
import { GoFilter } from "react-icons/go";
import { FilterModal } from "../components/modals/FilterModal";
import { useNavigate } from "react-router";
import ReactPaginate from "react-paginate";
import { notify } from "../components/actions/CommonActions";
import { IoCloseCircle } from "react-icons/io5";
import * as XLSX from "xlsx";
import { IoMdDownload } from "react-icons/io";
import { getPolicy, getUploadErrorNaicom, getUploadErrorNiid, uploadMember, uploadPolicy, reuploadPolicyApi, pushPolicy } from "../services";
import { saveAs } from 'file-saver';
import file from '../assets/group-life-policy-template.xlsx';
import file2 from "../assets/grouplife-members-template.xlsx"
import moment from "moment";
import '../App.css'
import { UpdatePolicyModal } from "../components/modals/UpdatePolicyModal";
import { HiOutlineDotsVertical } from "react-icons/hi";
import LoadingModal from "../components/modals/LoadingModal";
import ReasonModal from "../components/modals/ReasonModal";
import { NewPolicyModal } from "../components/modals/NewPolicyModal";

export const UploadedFiles = () => {
  const [filter, setFilter] = useState({
    mandateCode: "",
    subscriberCode: "",
    approverStatus: "",
    startDate: "",
    bank: "",
    dateApproved: "",
    amount: "",
    nextDebitDate: "",
    payer: "",
  });

  const [showFilter, setShowFilter] = useState(false);
  const [mandates, setMandates] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [numInput, setNumInput] = useState(10);
    const [showUser, setShowUser] = useState(false);

  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isTemplateLoading, setIsTemplateLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [isUploadMemberFile, setIsUploadMemberFile] = useState(false);
  const [batchFile, setBatchFile] = useState(null);
  const [batchMemberFile, setBatchMemberFile] = useState(null);
  const [errorFile, setErrorFile] = useState('');
  const [gottenPolicy, setPolicyGotten] = useState(null)
  const [showChange, setShowChange] = useState(false); const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);
  const [reason, setReason] = useState(null)
  const [loadingReason, setLoadingReason] = useState(false)
  const [reasonModal, setReasonModal] = useState(false)
  const [showMember, setShowMember] = useState(false)

  const toggleShowUser = () => {
    setShowUser(!showUser);
  };

  const toggleShowMember = () => {
    setShowMember(!showMember);
  };
  const toggleDropdown = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateDateFormat = (date) => {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return regex.test(date);
  };

  //New pagination logic test //

  const fetchMandates = async (page) => {
    setIsLoading(true);

  };



  useEffect(() => {
    const getRolesApi = async () => {
      setIsLoading(true)
      await getPolicy(numInput, 1)
        .then((res) => {
          setPolicyGotten(res?.data)
          setTotalPages(Number(res?.data?.totalCount) / Number(numInput))
        })
        .catch((error) => {
          notify("danger", "OOPS", error?.response?.data?.message);
          console.log('error ', error);
        })
      setIsLoading(false)
    }
    getRolesApi()
  }, [])

  const handleRefetch = async () => {
    setIsLoading(true)
    await getPolicy(numInput, 1)
      .then((res) => {
        setPolicyGotten(res?.data)
        setTotalPages(Number(res?.data?.totalCount) / Number(numInput))
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        console.log('error ', error);
      })
    setIsLoading(false)
  }

  const handleReasonNiid = async (id) => {
    setLoadingReason(true)
    let urlEndcoded = id?.replaceAll('-','/')
    await getUploadErrorNiid(urlEndcoded)
      .then((res) => {
        // console.log("reason info niid ", res?.data);
        setReason(res?.data)
        setReasonModal(true)
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        // console.log('error ', error);
      })
      setLoadingReason(false)
  }

  const handleReasonNaicom = async (id) => {
    setLoadingReason(true)
    let urlEndcoded = id?.replaceAll('-','/')
    await getUploadErrorNaicom(urlEndcoded)
      .then((res) => {
        // console.log("reason info naicom ", res?.data);
        setReason(res?.data)
        setReasonModal(true)
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        // console.log('error ', error);
      })
      setLoadingReason(false)
  }

  const handleReupload = async (policyNumber, regulator) => {
    setIsLoading(true);
    await reuploadPolicyApi(regulator, { policyNumber })
      .then((res) => {
        notify("success", "Success", res?.message || "Policy queued for re-upload");
        handleRefetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message || "Failed to request re-upload");
      });
    setIsLoading(false);
  };

  const handlePushPolicy = async (policyNumber, regulator = "ALL", force = false) => {
    setIsLoading(true);
    await pushPolicy(policyNumber, regulator, force)
      .then((res) => {
        notify("success", "Success", res?.message || `Policy ${policyNumber} pushed successfully`);
        handleRefetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message || "Failed to push policy");
      });
    setIsLoading(false);
  };

  const handleSetPageClick = async (data) => {
    console.log(numInput, currentPage);
    setIsLoading(true)
    await getPolicy(numInput, currentPage)
      .then((res) => {
        // console.log('res ',res);
        setPolicyGotten(res?.data);
        setTotalPages(Number(res?.data?.totalCount) / Number(numInput))
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        console.log('error ', error);
      })
    setIsLoading(false)
  };

  const handlePageClick = async (data) => {
    const selectedPage = data.selected + 1;
    setCurrentPage(selectedPage)
    setIsLoading(true)
    await getPolicy(numInput, selectedPage)
      .then((res) => {
        // console.log('res ',res);
        setPolicyGotten(res?.data);
        setTotalPages(Number(res?.data?.totalCount) / Number(numInput))
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        console.log('error ', error);
      })
    setIsLoading(false)
  };

  //New pagination logic test //

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  // console.log(banks);

  const handleChange = (e) => {
    const name = e.target.name;
    let value;
    switch (name) {
      case "frequency":
        value = parseInt(e.target.value);

        break;

      case "approverStatus":
        value = parseInt(e.target.value);

        break;

      default:
        value = e.target.value;
        break;
    }
    // const value = e.target.value;
    setFilter({ ...filter, [name]: value });
  };

  const frequencies = [
    { code: 1, name: "Monthly" },
    { code: 3, name: "Quarterly" },
    { code: 6, name: "Half-yearly" },
    { code: 12, name: "Yearly" },
    { code: 99, name: "Daily" },
  ];


  const handleFileChange = (e) => {
    setErrorFile("")
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet);

      for (let row of json) {
        if (
          (row['Commencement Date'] && !validateDateFormat(row['Commencement Date'])) ||
          (row['Expiry Date'] && !validateDateFormat(row['Expiry Date']))
        ) {
          setErrorFile(`Invalid date format in row: ${JSON.stringify(row)}. Date format should be DD/MM/YYYY`);
          return;
        }
      }

      setError(''); // Clear error if all dates are valid
      // Process data if needed
    };
    reader.readAsArrayBuffer(file);
    // console.log('file uploaded ',file);
    setBatchFile(file)

  };
  

  const handleFileMemberChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet);

      for (let row of json) {
        if (
          (row['Commencement Date'] && !validateDateFormat(row['Commencement Date'])) ||
          (row['Expiry Date'] && !validateDateFormat(row['Expiry Date']))
        ) {
          setErrorFile(`Invalid date format in row: ${JSON.stringify(row)}. Date format should be DD/MM/YYYY (text format)`);
          return;
        }
      }

      setError(''); // Clear error if all dates are valid
      // Process data if needed
    };
    reader.readAsArrayBuffer(file);
    // console.log('file uploaded ',file);
    setBatchMemberFile(file)

  };

  const dataLoadingStatus = [
    {
      id: 1,
      status: true,
    },
    {
      id: 0,
      status: false,
    },
  ];

  const handleSearch = async () => {
  };

  const handleUploadFile = async () => {
    setIsUploadFile(true);
    const formData = new FormData()
    formData.append('document', batchFile)
    await uploadPolicy(formData)
      .then((res) => {
        notify("success", "success", res?.message);
        setIsUploadFile(false);
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsUploadFile(false);
      });
  };

  const handleUploadMemberFile = async () => {
    setIsUploadMemberFile(true);
    const formData = new FormData()
    formData.append('document', batchMemberFile)
    await uploadMember(formData)
      .then((res) => {
        notify("success", "success", res?.message);
        setIsUploadMemberFile(false);
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsUploadMemberFile(false);
      });
  };

  const handleDownloadPolicyTemplate = async () => {
    const token = sessionStorage.getItem("token") || null;
    setIsTemplateLoading(true);
    fetch(file)
      .then(response => response.blob())
      .then(blob => {
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'group-life-policy-template.xlsx'; // Specify the filename

        // Append the link to the body
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);

        // Revoke the object URL after download
        URL.revokeObjectURL(link.href);
      })
      .catch(err => console.error('Download failed:', err));
    setIsTemplateLoading(false);
  };

  const handleDownloadMemberTemplate = async () => {
    const token = sessionStorage.getItem("token") || null;
    setIsTemplateLoading(true);
    fetch(file2)
      .then(response => response.blob())
      .then(blob => {
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'grouplife-members-template.xlsx'; // Specify the filename

        // Append the link to the body
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);

        // Revoke the object URL after download
        URL.revokeObjectURL(link.href);
      })
      .catch(err => console.error('Download failed:', err));
    setIsTemplateLoading(false);
  };

  const toggleShowChange = () => {
    setShowChange(!showChange);
  };

  const dataToRender = filteredData.length > 0 ? filteredData : mandates;

  const navigate = useNavigate();
  return (
    <>
      <div className="upload-grid">
        <div className="upload-card">
          <div className="upload-card__title">
            <span className="upload-card__icon">
              <FiDownload />
            </span>
            Policy file
          </div>
          <p className="upload-card__hint">
            Excel file with the policy details. Uploading a policy that already
            exists recreates it and invalidates its previous members.
          </p>
          <InputGroup>
            <Form.Control
              type="file"
              placeholder="Upload excel file."
              name="excelFile"
              onChange={handleFileChange}
            />
            <Button
              variant="primary"
              onClick={(e) => {
                e.preventDefault();
                handleUploadFile();
              }}
              disabled={isUploadFile}
            >
              {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload"}
            </Button>
          </InputGroup>
          {errorFile && (
            <div className="mt-2" style={{ color: "var(--danger)", fontSize: "0.78rem" }}>
              {errorFile}
            </div>
          )}
          <div className="upload-card__footer">
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={(e) => {
                e.preventDefault();
                handleDownloadPolicyTemplate();
              }}
            >
              <IoMdDownload /> Download policy template
            </button>
          </div>
        </div>

        <div className="upload-card">
          <div className="upload-card__title">
            <span className="upload-card__icon">
              <FiDownload />
            </span>
            Member file
          </div>
          <p className="upload-card__hint">
            Excel file with the members of a policy. The uploaded members
            replace the ones already on the policy.
          </p>
          <InputGroup>
            <Form.Control
              type="file"
              placeholder="Upload excel file."
              name="excelFile"
              onChange={handleFileMemberChange}
            />
            <Button
              variant="primary"
              onClick={(e) => {
                e.preventDefault();
                handleUploadMemberFile();
              }}
              disabled={isUploadMemberFile}
            >
              {isUploadMemberFile ? (
                <FiRefreshCcw className="spin" />
              ) : (
                "Upload"
              )}
            </Button>
          </InputGroup>
          <div className="upload-card__footer">
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={(e) => {
                e.preventDefault();
                handleDownloadMemberTemplate();
              }}
            >
              <IoMdDownload /> Download member template
            </button>
          </div>
        </div>
      </div>

      <div className="surface-card surface-card--flush">
        <div className="surface-card__header">
          <div>
            <div className="surface-card__title">All policies</div>
            <div className="surface-card__meta">
              {gottenPolicy?.totalCount || 0} policies in the portal
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            {isFilterActive && (
              <button
                className="light-button"
                onClick={(e) => {
                  e.preventDefault();
                  setShowFilter(false);
                  sessionStorage.removeItem("filteredValues");
                  sessionStorage.removeItem("isFilterActiveButton");
                  handleRefetch();
                  window.location.reload();
                }}
              >
                <IoCloseCircle /> Clear filters
              </button>
            )}
            <button className="light-button" onClick={toggleFilter}>
              <GoFilter /> Filter
            </button>
          </div>
        </div>

        <div className="table-scroll">
          <table className="fl-table">
            <thead>
              <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                <th>Policy</th>
                <th>Insured</th>
                <th>Mobile</th>
                <th>Commencement</th>
                <th>Expiry</th>
                <th>NAICOM ID</th>
                <th>NIID</th>
                <th>NAICOM</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                Array.from({ length: 6 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    {Array.from({ length: 9 }).map((__, cell) => (
                      <td key={cell}>
                        <div className="skeleton-row" style={{ width: `${60 + ((index + cell) % 4) * 10}%` }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : error ? (
                <tr>
                  <td colSpan="9">
                    <div className="empty-state">
                      <div className="empty-state__title">Could not load policies</div>
                      <div>{error}</div>
                    </div>
                  </td>
                </tr>
              ) : gottenPolicy?.policies?.length === 0 ? (
                <tr>
                  <td colSpan="9">
                    <div className="empty-state">
                      <div className="empty-state__title">No policies yet</div>
                      <div>
                        Upload a policy file to get started, then push it to NIID
                        and NAICOM.
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                gottenPolicy?.policies?.map((mandate) => (
                  <tr className="tr" key={mandate.id}>
                    <td className="gray-td">
                      <div className="cell-primary">{mandate?.policyNumber}</div>
                      <div className="cell-secondary" title={mandate?.officeAddress}>
                        {mandate?.officeAddress}
                      </div>
                    </td>
                    <td className="gray-td">
                      <div
                        className="cell-primary cell-primary--clip"
                        title={mandate?.insured}
                      >
                        {mandate?.insured}
                      </div>
                      <div className="cell-secondary">
                        {mandate?.noOfEmployees} employees
                      </div>
                    </td>
                    <td className="gray-td cell-mono">{mandate?.mobileNumber}</td>
                    <td className="gray-td cell-mono">
                      {moment(mandate?.commencementDate).format("YYYY-MM-DD")}
                    </td>
                    <td className="gray-td cell-mono">
                      {moment(mandate?.expiryDate).format("YYYY-MM-DD")}
                    </td>
                    <td className="gray-td cell-mono">
                      {mandate?.naicomUniquePolicyId ? (
                        <span
                          className="cell-mono--clip"
                          title={mandate?.naicomUniquePolicyId}
                        >
                          {mandate?.naicomUniquePolicyId}
                        </span>
                      ) : (
                        <span className="cell-secondary">—</span>
                      )}
                    </td>

                    {/* NIID status */}
                    <td className="gray-td">
                      <div className="d-flex align-items-center gap-2 status-cell">
                        {mandate?.uploadedToNiid ? (
                          <span className="status-pill status-pill--success">
                            <span className="status-pill__dot" />
                            Uploaded
                          </span>
                        ) : mandate?.errored ? (
                          <button
                            className="status-pill status-pill--danger status-pill--action"
                            onClick={() => handleReasonNiid(mandate?.policyNumber)}
                            title="View the failure reason"
                          >
                            <span className="status-pill__dot" />
                            Failed
                          </button>
                        ) : (
                          <span className="status-pill status-pill--warning">
                            <span className="status-pill__dot" />
                            Pending
                          </span>
                        )}
                      </div>
                    </td>

                    {/* NAICOM status */}
                    <td className="gray-td">
                      <div className="d-flex align-items-center gap-2 status-cell">
                        {mandate?.uploadedToNaicom ? (
                          <span className="status-pill status-pill--success">
                            <span className="status-pill__dot" />
                            Uploaded
                          </span>
                        ) : mandate?.erroredAtNaicom ? (
                          <button
                            className="status-pill status-pill--danger status-pill--action"
                            onClick={() => handleReasonNaicom(mandate?.policyNumber)}
                            title="View the failure reason"
                          >
                            <span className="status-pill__dot" />
                            Failed
                          </button>
                        ) : (
                          <span className="status-pill status-pill--warning">
                            <span className="status-pill__dot" />
                            Pending
                          </span>
                        )}
                      </div>
                    </td>

                    {/* Actions */}
                    <td style={{ textAlign: "right" }}>
                      <div className="relative" style={{ position: "relative" }}>
                        <button
                          onClick={() => toggleDropdown(mandate.id)}
                          className="dotsBtn"
                          aria-label="Policy actions"
                        >
                          <HiOutlineDotsVertical />
                        </button>

                        {openDropdownId === mandate.id && (
                          <div className="dropdownSelect" ref={dropdownRef}>
                            <div className="updateBtn">
                              <button
                                onClick={() => {
                                  navigate(
                                    `/policy-details/${mandate.policyNumber?.replaceAll(
                                      "/",
                                      "-"
                                    )}`,
                                    { state: { idNew: mandate?.policyNumber } }
                                  );
                                }}
                              >
                                View policy
                              </button>
                              <button
                                onClick={() => {
                                  toggleShowChange();
                                  setSelectedPolicy(mandate);
                                  setOpenDropdownId(null);
                                }}
                              >
                                Update policy
                              </button>
                              <button
                                onClick={() => {
                                  setOpenDropdownId(null);
                                  handlePushPolicy(mandate?.policyNumber, "NAICOM");
                                }}
                              >
                                Push to NAICOM
                              </button>
                              <button
                                onClick={() => {
                                  setOpenDropdownId(null);
                                  handlePushPolicy(mandate?.policyNumber, "NIID");
                                }}
                              >
                                Push to NIID
                              </button>
                              <button
                                onClick={() => {
                                  setOpenDropdownId(null);
                                  handlePushPolicy(mandate?.policyNumber, "ALL");
                                }}
                              >
                                Push to both
                              </button>
                              {!mandate?.uploadedToNiid && (
                                <button
                                  onClick={() => {
                                    setOpenDropdownId(null);
                                    handleReupload(mandate?.policyNumber, "NIID");
                                  }}
                                >
                                  Retry NIID upload
                                </button>
                              )}
                              {!mandate?.uploadedToNaicom && (
                                <button
                                  onClick={() => {
                                    setOpenDropdownId(null);
                                    handleReupload(mandate?.policyNumber, "NAICOM");
                                  }}
                                >
                                  Retry NAICOM upload
                                </button>
                              )}
                              {mandate?.uploadedToNaicom && (
                                <button
                                  style={{ color: "var(--warning)" }}
                                  onClick={() => {
                                    setOpenDropdownId(null);
                                    handlePushPolicy(
                                      mandate?.policyNumber,
                                      "NAICOM",
                                      true
                                    );
                                  }}
                                >
                                  Force re-push to NAICOM
                                </button>
                              )}
                              {mandate?.uploadedToNiid && (
                                <button
                                  style={{ color: "var(--warning)" }}
                                  onClick={() => {
                                    setOpenDropdownId(null);
                                    handlePushPolicy(
                                      mandate?.policyNumber,
                                      "NIID",
                                      true
                                    );
                                  }}
                                >
                                  Force re-push to NIID
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <div className="d-flex align-items-center gap-2">
            <span className="surface-card__meta">Items per page:</span>
            <Form.Select
              size="sm"
              value={numInput}
              onChange={async (e) => {
                const val = parseInt(e.target.value);
                setNumInput(val);
                sessionStorage.setItem("pageNum", val);
                setIsLoading(true);
                await getPolicy(val, 1)
                  .then((res) => {
                    setPolicyGotten(res?.data);
                    setTotalPages(Math.ceil(Number(res?.data?.totalCount) / val));
                    setCurrentPage(1);
                  })
                  .catch((error) => {
                    notify("danger", "OOPS", error?.response?.data?.message);
                  });
                setIsLoading(false);
              }}
              style={{ width: "84px" }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
          </div>

          <div className="d-flex align-items-center justify-content-center">
            <ReactPaginate
              pageCount={totalPages}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName="pagination mb-0 d-flex gap-1 list-unstyled align-items-center"
              activeClassName="active"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link border-0 text-muted px-2 py-2"
              activeLinkClassName="bg-primary text-white"
              previousLabel={"← Previous"}
              nextLabel={"Next →"}
              forcePage={currentPage - 1}
            />
          </div>
        </div>
      </div>

      <FilterModal
        toggleFilter={toggleFilter}
        showFilter={showFilter}
        handleChange={handleChange}
        handleSearch={handleSearch}
        filterLoading={filterLoading}
        dataLoadingStatus={dataLoadingStatus}
        isFilterActive={isFilterActive}
        setIsFilterActive={setIsFilterActive}
      />
      <NewPolicyModal
        showUser={showUser}
        setShowUser={setShowUser}
        toggleShowUser={toggleShowUser}
        refetch={handleRefetch}
      />

      <UpdatePolicyModal
        showUser={showChange}
        toggleShowUser={toggleShowChange}
        refetch={handleRefetch}
        selectedPolicy={selectedPolicy}
      />

      <LoadingModal show={loadingReason} />

      <ReasonModal
        show={reasonModal}
        onHide={() => setReasonModal(false)}
        description={reason?.reason}
      />
    </>
  );
};
